import { useRef } from "react";
import { TooltipContainer } from "@outplayed/tooltips";
import DefaultSelect from "components/DefaultSelect";

interface LaneSelectProps {
  options: { [key: string]: string }[];
  onFilterChange: (type: string, value: string) => void;
  isMobile?: boolean;
  value: any;
}

const LaneSelect = (props: LaneSelectProps) => {
  const { options, onFilterChange, isMobile, value } = props;
  const tooltipRef = useRef<{ forceClose: Function }>({ forceClose: () => {} });

  return (
    <>
      <TooltipContainer ref={tooltipRef} tooltipInfo={"Change Lane Type"} disableTooltip={isMobile}>
        <div>
          <DefaultSelect
            title={"Change Lane Type"}
            group={"lane"}
            options={options}
            onChange={(selected: (typeof options)[number]) => {
              onFilterChange("lane", selected.value);
            }}
            value={value}
            formatOptionLabel={(option: { value: string; label: string }) => {
              return <span>{option.label}</span>;
            }}
            width={170}
            isSearchable={false}
            isMobile={isMobile}
            onMenuClose={() => tooltipRef.current.forceClose()}
          />
        </div>
      </TooltipContainer>
    </>
  );
};

export { LaneSelectProps, LaneSelect };
